import { useEffect, useRef, useState } from "react";
import { Loader2Icon, TimerOffIcon } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { request } from "@/lib/request";

export const ChangePasswordRequest = () => {
  const [loading, setLoading] = useState(false);
  const [disableTimeout, setDisableTimeout] = useState(false);
  const timerRef = useRef<number | null>(null);

  const requestPasswordChange = async () => {
    setLoading(true);
    try {
      await request.post(`/auth/change-password`).catch(err => {
        throw new Error(
          err.response?.data.message
            ? err.response?.data.message
            : "Something went wrong, please try again.",
        );
      });

      toast.success("Request submitted", {
        description: "Please check your email for further instructions.",
      });
      setDisableTimeout(true);
      timerRef.current = window.setTimeout(
        () => {
          setDisableTimeout(false);
        },
        0.5 * 60 * 1000,
      );
    } catch (err) {
      toast.error(err instanceof Error ? err.message : "An error occurred");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  return (
    <Button
      size="sm"
      variant="secondary"
      type="button"
      onClick={requestPasswordChange}
      disabled={loading || disableTimeout}
    >
      {disableTimeout ? (
        <>
          <TimerOffIcon />
          Please wait
        </>
      ) : loading ? (
        <>
          <Loader2Icon className="animate-spin" />
          Sending
        </>
      ) : (
        "Change Password"
      )}
    </Button>
  );
};
